"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GraphQLPage = void 0;
const lib_env_1 = __importDefault(require("@opsbase/lib-env"));
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const lib_storage_1 = require("@opsbase/lib-storage");
const useSelf_1 = __importDefault(require("@opsbase/react-ctrl-self/useSelf"));
const web_css_1 = __importDefault(require("@opsbase/web-css"));
const Pane_1 = __importDefault(require("@opsbase/web-layout/Pane"));
const Vertical_1 = __importDefault(require("@opsbase/web-layout/Vertical/Vertical"));
const Accordion_1 = __importDefault(require("@opsbase/web-ui/Accordion/Accordion"));
const AccordionDetails_1 = __importDefault(require("@opsbase/web-ui/AccordionDetails/AccordionDetails"));
const AccordionSummary_1 = __importDefault(require("@opsbase/web-ui/AccordionSummary/AccordionSummary"));
const react_1 = __importStar(require("react"));
const AppPage_1 = __importDefault(require("../AppPage"));
const makeMyClasses = () => ({
    frame: {
        border: '1px solid ' + lib_palette_1.default.InputBorderGrey.main,
        borderRadius: 4,
        height: '100%',
        width: '100%',
    },
    frame2: {
        border: 0,
        minHeight: 400,
        width: '100%',
    },
});
function GraphQLPage() {
    const myCss = (0, web_css_1.default)(makeMyClasses);
    const self = (0, useSelf_1.default)(true);
    const [helpExpanded, setHelpExpanded] = (0, react_1.useState)(false);
    const currentAccessToken = self.isSuperUser
        ? (0, lib_storage_1.getStoredValue)('shadowAccessToken')
        : (0, lib_storage_1.getStoredValue)('accessToken');
    const currentRefreshToken = self.isSuperUser
        ? (0, lib_storage_1.getStoredValue)('shadowRefreshToken')
        : (0, lib_storage_1.getStoredValue)('refreshToken');
    const [url] = (0, react_1.useState)(calcUrl(currentAccessToken, currentRefreshToken));
    return (react_1.default.createElement(AppPage_1.default, null,
        react_1.default.createElement(Vertical_1.default, { gutter: true, padding: true },
            react_1.default.createElement(Pane_1.default, { grow: true },
                react_1.default.createElement("iframe", { className: myCss.frame, src: url })),
            react_1.default.createElement(Accordion_1.default, { expanded: helpExpanded, onChange: () => setHelpExpanded(!helpExpanded) },
                react_1.default.createElement(AccordionSummary_1.default, null, lib_i18n_1.default.t('api-help')),
                react_1.default.createElement(AccordionDetails_1.default, null,
                    react_1.default.createElement("iframe", { className: myCss.frame2, src: 'https://docs.opsbase.com/dataapi/datatypes.html' }))))));
}
exports.GraphQLPage = GraphQLPage;
exports.default = GraphQLPage;
function calcUrl(accessToken, refreshToken) {
    return (lib_env_1.default.apis.graphql +
        '/playground?authorization=' +
        encodeURI(accessToken) +
        '&refresh-token=' +
        encodeURI(refreshToken));
}
